import { useEffect } from "react";
import "./App.css";
import { trackScrollDepth, trackTimeOnPage } from "./analytics";

import Nav              from "./components/Nav";
import ScrollAtmosphere from "./components/ScrollAtmosphere";
import Hero             from "./components/Hero";
import HowItWorks       from "./components/HowItWorks";
import ForWho           from "./components/ForWho";
import Features         from "./components/Features";
import Reviews          from "./components/Reviews";
import FAQ              from "./components/FAQ";
import DownloadCTA      from "./components/DownloadCTA";
import Footer           from "./components/Footer";

export default function App() {
  // Scroll depth tracking
  useEffect(() => {
    const milestones = [25, 50, 75, 90, 100];
    const reached = new Set();

    const onScroll = () => {
      const scrolled = window.scrollY + window.innerHeight;
      const total    = document.documentElement.scrollHeight;
      const pct      = Math.round((scrolled / total) * 100);

      milestones.forEach(m => {
        if (pct >= m && !reached.has(m)) {
          reached.add(m);
          trackScrollDepth(m);
        }
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Time on page tracking (fires on tab close / navigate away)
  useEffect(() => {
    const startedAt = Date.now();

    const onLeave = () => {
      const seconds = Math.round((Date.now() - startedAt) / 1000);
      trackTimeOnPage(seconds);
    };

    window.addEventListener("beforeunload", onLeave);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") onLeave();
    });

    return () => {
      window.removeEventListener("beforeunload", onLeave);
    };
  }, []);

  return (
    <>
      <ScrollAtmosphere />
      <Nav />
      <main>
        <Hero />
        <Reviews />
        <HowItWorks />
        <ForWho />
        <Features />
        <FAQ />
        <DownloadCTA />
      </main>
      <Footer />
    </>
  );
}
